@file:OptIn(InternalResourceApi::class)

package mobile_wallet.core.designsystem.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mobile_wallet.core.designsystem.generated.resources/"

public val Res.font.outfit_black: FontResource by lazy {
      FontResource("font:outfit_black", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_black.ttf", -1, -1),
      ))
    }

public val Res.font.outfit_bold: FontResource by lazy {
      FontResource("font:outfit_bold", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_bold.ttf", -1, -1),
      ))
    }

public val Res.font.outfit_extra_bold: FontResource by lazy {
      FontResource("font:outfit_extra_bold", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_extra_bold.ttf", -1, -1),
      ))
    }

public val Res.font.outfit_extra_light: FontResource by lazy {
      FontResource("font:outfit_extra_light", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_extra_light.ttf", -1, -1),
      ))
    }

public val Res.font.outfit_light: FontResource by lazy {
      FontResource("font:outfit_light", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_light.ttf", -1, -1),
      ))
    }

public val Res.font.outfit_medium: FontResource by lazy {
      FontResource("font:outfit_medium", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_medium.ttf", -1, -1),
      ))
    }

public val Res.font.outfit_regular: FontResource by lazy {
      FontResource("font:outfit_regular", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_regular.ttf", -1, -1),
      ))
    }

public val Res.font.outfit_semi_bold: FontResource by lazy {
      FontResource("font:outfit_semi_bold", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_semi_bold.ttf", -1, -1),
      ))
    }

public val Res.font.outfit_thin: FontResource by lazy {
      FontResource("font:outfit_thin", setOf(
        ResourceItem(setOf(), "${MD}font/outfit_thin.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("outfit_black", Res.font.outfit_black)
  map.put("outfit_bold", Res.font.outfit_bold)
  map.put("outfit_extra_bold", Res.font.outfit_extra_bold)
  map.put("outfit_extra_light", Res.font.outfit_extra_light)
  map.put("outfit_light", Res.font.outfit_light)
  map.put("outfit_medium", Res.font.outfit_medium)
  map.put("outfit_regular", Res.font.outfit_regular)
  map.put("outfit_semi_bold", Res.font.outfit_semi_bold)
  map.put("outfit_thin", Res.font.outfit_thin)
}
